import { Injectable } from '@angular/core';
import { SwodocArticle } from './swodoc-node-article-data-single-order';

/**
 * Service to maintain article checkbox state across wizard navigation
 * This prevents the checkbox state from being lost when the component is recreated
 */
@Injectable({
  providedIn: 'root',
})
export class SwodocNodeArticleDataSingleOrderService {
  private articleStateMap: Map<string, SwodocArticle[]> = new Map();

  /**
   * Store article state for a specific node
   * @param nodeId The ID of the node
   * @param articles The articles with their checkbox states
   */
  public saveArticleState(nodeId: string, articles: SwodocArticle[]): void {
    // Create a deep copy to prevent reference issues
    const articlesCopy = articles.map(article => ({ ...article }));
    this.articleStateMap.set(nodeId, articlesCopy);
  }

  /**
   * Get stored article state for a specific node
   * @param nodeId The ID of the node
   * @returns The stored articles with their checkbox states, or undefined if not found
   */
  public getArticleState(nodeId: string): SwodocArticle[] | undefined {
    return this.articleStateMap.get(nodeId);
  }

  /**
   * Check if we have stored state for a specific node
   * @param nodeId The ID of the node
   * @returns True if state exists for this node
   */
  public hasArticleState(nodeId: string): boolean {
    return this.articleStateMap.has(nodeId);
  }

  /**
   * Clear all stored article states
   */
  public clearAllStates(): void {
    this.articleStateMap.clear();
  }
}
